import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import {
    renderFieldKM,
    renderFieldNumber,
    renderFieldSelect,
    renderField,
    requiredSelect,
} from '../../util/inputs';
import Autorizacao from '../../security/Autorizacao';
import Titulo from '../comum/Titulo';
import { PERFIL_ADMIN } from '../../security/securityContext';
import buscarOpcoesFiltroAdesaoPontos from '../../actions/adesao-pontos/buscarOpcoesFiltroAdesaoPontos';
import cadastrarConfiguracaoPonto from '../../actions/adesao-pontos/cadastrarConfiguracaoPonto';
import { showSuccessMsg } from '../../util/messagesUtil';
import selecionarAdesaoPonto from '../../actions/adesao-pontos/selecionarAdesaoPonto';

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

const renderToggle = ({ input }) => (
    <label className="vx-switch" style={{ cursor: 'pointer', flexShrink: 0 }}>
        <input {...input} type="checkbox" />
        <span className="vx-switch-slider" />
    </label>
);

export class PainelCadastroConfiguracaoPonto extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        this.props.buscarOpcoesFiltroAdesaoPontos();
    }

    montarParametros(values) {
        return {
            empresaId: this.props.adesaoPontoSelecionado.id
                ? this.props.adesaoPontoSelecionado.empresa.id
                : values.empresa.value.chave,
            peso: values.peso,
            ponto: values.ponto,
            habilitadoGeracaoPontos: values.habilitadoGeracaoPontos,
            habilitadoConsumoPontos: values.habilitadoConsumoPontos,
        };
    }

    submit(values) {
        this.props.cadastrarConfiguracaoPonto(this.montarParametros(values))
            .then(() => {
                showSuccessMsg('A configuração foi salva com sucesso!');
                this.props.history.push('/painel-gerenciar-adesao-pontos');
            });
    }

    render() {
        const { handleSubmit, invalid, submitting } = this.props;
        const ehEdicao = !!this.props.adesaoPontoSelecionado.id;
        const urlRetorno = ehEdicao ? '/painel-gerenciar-adesao-pontos' : '/menu-adesao-pontos';

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="container-padrao">
                    <Titulo
                        texto={ehEdicao ? 'Editar Configuração de Pontos' : 'Nova Configuração de Pontos'}
                        urlRetorno={urlRetorno}
                    />
                    <form onSubmit={handleSubmit(this.submit)} className="vx-config-page">

                        <SectionCard icon="stars" title="Dados da Empresa" subtitle="Empresa e parâmetros de pontuação">
                            <div style={{ marginBottom: 16 }}>
                                {!ehEdicao ? (
                                    <Field name='empresa'
                                        options={(this.props.empresas || []).map(elemento => ({
                                            descricao: `${elemento.chave} — ${elemento.valor}`,
                                            nome: elemento,
                                        }))}
                                        component={renderFieldSelect}
                                        label="Empresa:"
                                        placeholder='Selecione uma empresa'
                                        validate={requiredSelect}
                                        menuPortalTarget={document.body}
                                    />
                                ) : (
                                    <Field name="empresa" type="text" component={renderField}
                                        label="Empresa:" css="form-control" readOnly />
                                )}
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                                <Field name="peso" component={renderFieldKM}
                                    label="Peso:" css="form-control" readOnly={false} />
                                <Field name="ponto" type="text" component={renderFieldNumber}
                                    formatacao='#########'
                                    readOnly={false}
                                    label="Quantidade de Pontos:"
                                    css="form-control" />
                            </div>
                        </SectionCard>

                        <SectionCard icon="toggle_on" title="Habilitações" subtitle="Ative ou desative as funcionalidades de pontos para a empresa">
                            <div className="vx-toggle-row">
                                <div className="vx-toggle-info">
                                    <div className="vx-toggle-info-title">Geração de Pontos</div>
                                    <div className="vx-toggle-info-desc">Habilita o acúmulo de pontos nas compras de passagem</div>
                                </div>
                                <Field name='habilitadoGeracaoPontos' type="checkbox" component={renderToggle} />
                            </div>
                            <div className="vx-toggle-row">
                                <div className="vx-toggle-info">
                                    <div className="vx-toggle-info-title">Consumo de Pontos</div>
                                    <div className="vx-toggle-info-desc">Habilita o uso de pontos como desconto na compra</div>
                                </div>
                                <Field name='habilitadoConsumoPontos' type="checkbox" component={renderToggle} />
                            </div>
                        </SectionCard>

                        <div className="vx-config-save-bar">
                            <span className="vx-config-save-hint">
                                <i className="material-icons">info_outline</i>
                                {ehEdicao ? 'Editando configuração existente' : 'Nova configuração será criada para a empresa'}
                            </span>
                            <button type="submit"
                                disabled={invalid || submitting}
                                className="btn btn-laranja vx-config-save-btn">
                                <i className="material-icons">save</i>
                                {ehEdicao ? 'Salvar Alterações' : 'Cadastrar'}
                            </button>
                        </div>

                    </form>
                </div>
            </Autorizacao>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            empresa: `${state.adesaoPontoSelecionado.empresa.id} - ${state.adesaoPontoSelecionado.empresa.nome}`,
            peso: state.adesaoPontoSelecionado.peso,
            ponto: state.adesaoPontoSelecionado.quantidadePonto,
            habilitadoGeracaoPontos: state.adesaoPontoSelecionado.habilitadoGeracaoPontos,
            habilitadoConsumoPontos: state.adesaoPontoSelecionado.habilitadoConsumoPontos,
        },
        empresas: state.opcoesFiltrosAdesaoPontos.empresas,
        habilitadoConsumoPontos: formValueSelector('formularioCadastrarConfiguracaoPontos')(state, 'habilitadoConsumoPontos'),
        adesaoPontoSelecionado: state.adesaoPontoSelecionado,
    };
}

export default withRouter(connect(mapStateToProps, {
    buscarOpcoesFiltroAdesaoPontos,
    cadastrarConfiguracaoPonto,
    selecionarAdesaoPonto,
    changeFieldValue,
})(reduxForm({
    form: 'formularioCadastrarConfiguracaoPontos',
})(PainelCadastroConfiguracaoPonto)));
